export const GET_TRANSACTION = 'TRANSACTION/get_transaction'; // dummy
export const GET_TRANSACTION_COUNTS = 'TRANSACTION/get_transaction_counts';

export const GET_ORDINANCE_REVISION_EFFECTIVITY =
  'GET_ORDINANCE_REVISION_EFFECTIVITY/get_ordinance_revision_effectivity';
export const GET_FORMDATA_ORDINANCE_REVISION =
  'GET_FORMDATA_ORDINANCE_REVISION/get_formdata_ordinance_revision';
export const GET_FORMDATA_ORDINANCE_REVISION_DEFAULT =
  'GET_FORMDATA_ORDINANCE_REVISION_DEFAULT/get_formdata_ordinance_revision_default';

export const APPLY_DISCOUNT = 'BPLS/apply_discount';
